import { arrToObj, randomInt, randomString } from 'utils/generic';
import { groupNames } from 'data/groupNames.js';
import { accountNames } from 'data/accountNames.js';
import { accountFilters } from 'constants/filters';

export const createRandomState = (
  accountCount = 36,
  periodCount = 2,
  groupCount = 10
) => {
  let periodIds = [...Array(periodCount).keys()].map((id) => 'period' + id);
  let accountIds = [...Array(accountCount).keys()];
  let groupIds = [...Array(groupCount + 1).keys()];
  let availableGroupIds = groupIds.filter((id) => id !== 0);

  return {
    client: {
      name: 'Client',
    },
    accounts: {
      periodIds,
      periodIdMax: periodCount - 1,
      accountIds,
      periodsById: arrToObj(periodIds.map(createRandomPeriod)),
      accountsById: arrToObj(
        accountIds.map((id) => createRandomAccount(id, periodIds, groupIds))
      ),
      filter: accountFilters.ALL,
    },
    groups: {
      groupsById: arrToObj(
        groupIds.map((id) => createRandomGroup(id, availableGroupIds))
      ),
      groupIdMax: groupCount,
    },
    journal: {
      entriesById: {
        /*
        1: {
          periodId: "period0",
          type: "aje",
          description: "AJE entry 1",
          status: "posted",
          modified: new Date(),
        }
        */
      },
      entryItemsById: {
        /*
        1: {
          entryId: 1,
          contentType: "account",
          contentId: 1,
          debit: 0,
          credit: 0,
        },
        */
      },
    },
    kpi: {
      entriesById: {
        /*
        1: {
          name: "PKI 1",
          groupId: 1,
          equation: "a^2 + b = c",
          ...
        },
         */
      },
      groupIds: [], // used for group order in KpiGrid
      groupIdMax: 0, // so that new group does not take some old id
      entryIdMax: 0, // so that new entry does not take some old id
      groupsById: {
        /*
        1: {
          name: "PKI Group 1",
          ...
        },
         */
      },
    },
    settings: {
      decimalSeparator: ',',
      thousandsSeparator: '.',
      groupsPrecision: -1,
      precision: 2,
      exchangeRates: [],
    },
    consolidations: {
      subsidiaryIds: [],
      subsidiariesById: {},
      cgroupsById: {},
      /*
      subsidiaryIds: [0],
      subsidiariesById: {
        0: {
          filename: "subcompany.cf",
          name: "SubCompany",
          updated: "2019-07-05T10:22:52.495Z",
          periodsMap: {
            period0: "period1",
            period1: "period2",
            period2: null
          }
        }
      },
      cgroupsById: { // TODO make generator
        0: {
          subId: 0,
          cfGroupId: 1,
          cfPeriods: {
            period1: 10,
            period2: 100
          }
        }
      }
      */
    },
    modals: [],
    previousState: {},
  };
};

function createRandomPeriod(periodId) {
  return {
    [periodId]: {
      name: randomString(6),
      description: randomString(10),
    },
  };
}

function createRandomAccount(accountId, periodIds, groupIds) {
  const [number, description] = accountNames[randomInt(accountNames.length)];
  return {
    [accountId]: {
      number,
      description,
      groupId: randomInt(10) ? groupIds[randomInt(groupIds.length)] : null,
      periods: Object.assign(
        {},
        ...periodIds.map((k) => ({
          [k]: {
            unadjusted: randomInt(100),
          },
        }))
      ),
    },
  };
}

function createRandomGroup(groupId, availableGroupIds) {
  return {
    [groupId]: {
      name: groupId
        ? groupNames[randomInt(groupNames.length)]
        : 'Financial statement',
      childrenIds: availableGroupIds.splice(0, availableGroupIds.length),
      code: '',
      number: '',
      cgroupId: groupId === 1 ? 0 : null, //TODO
      expanded: true,
    },
  };
}

export const createEmptyState = () => createRandomState(0, 0, 0);
